import React, { useCallback } from 'react';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import SelectInput from '../../../../elements/forms/SelectInput/SelectInput';

const NULL_VALUE = '--null--';

function LeadTimeframe(props) {
    const { lead, onChange } = props,
        { timeframe } = lead ?? {},
        i18n = useI18n();

    const handleTimeframeChange = useCallback(
        (value) => {
            let timeframe = value;
            if (timeframe === NULL_VALUE) timeframe = null;
            else timeframe = parseInt(timeframe);

            onChange({ timeframe });
        },
        [onChange]
    );

    return (
        <>
            <label htmlFor="timeframe">{i18n['label.timeframe']}</label>
            <SelectInput id="timeframe" value={timeframe ?? NULL_VALUE} onChange={handleTimeframeChange}>
                <option value="3">{i18n['option.timeline-3']}</option>
                <option value="7">{i18n['option.timeline-7']}</option>
                <option value="14">{i18n['option.timeline-14']}</option>
                <option value="28">{i18n['option.timeline-28']}</option>
                <option value="91">{i18n['option.timeline-91']}</option>
                <option value="365">{i18n['option.timeline-365']}</option>
                <option value={NULL_VALUE}>{i18n['option.timeline-null']}</option>
            </SelectInput>
        </>
    );
}

export default LeadTimeframe;
